import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon, Header, Label } from 'semantic-ui-react';
import i18next from 'i18next';

import { DataGrid } from '../../common';
import { parseBenefitToText } from '../../../helpers/benefits-parser';
import { fetchLoyaltyProgramCampaigns, fetchCampaignReport, fetchCampaignUsagesReport } from '../../../actions';

import './CampaignDetails.scss';

class CampaignDetails extends Component {

    componentWillMount() {
        const {
            loyaltyProgramId,
            campaignId,
            fetchLoyaltyProgramCampaigns,
            fetchCampaignReport,
            fetchCampaignUsagesReport
        } = this.props;

        if (loyaltyProgramId && campaignId) {
            fetchLoyaltyProgramCampaigns(loyaltyProgramId);
            fetchCampaignReport({ loyaltyProgramId, campaignId });
            fetchCampaignUsagesReport({ loyaltyProgramId, campaignId });
        }
    }

    render() {
        const { loyaltyProgramId, campaign, campaignReport, campaignUsagesReport } = this.props;
        const orderTypes = ['sitting', 'takeaway', 'delivery'];

        if (!campaign || !campaignUsagesReport) return null;

        const columns = [{
            id: 'index',
            Header: '#',
            maxWidth: 50,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            Cell: row => ++row.index
        }, {
            Header: i18next.t('loyaltyProgram.benefitName'),
            accessor: 'benefit.description',
            filterable: true
        }, {
            id: "benefitCode",
            Header: i18next.t('loyaltyProgram.benefitCode'),
            accessor: purchase => purchase.issue.code ? purchase.issue.code.replace(/\"/g, "") : '',
            filterable: true,
        }, {
            id: 'benefitType',
            Header: i18next.t('loyaltyProgram.benefitType'),
            accessor: row => row ? parseBenefitToText(row.benefit, undefined) : '',
            filterable: true
        }, {
            Header: i18next.t('restaurant'),
            accessor: 'restaurant.name',
            filterable: true
        }, {
            Header: i18next.t('loyaltyProgram.clientName'),
            accessor: 'user.name',
            Cell: row => {
                const purchase = row.original;
                return <a href={`/loyaltyProgram/${loyaltyProgramId}/members/${purchase.user.id}`}>{row.value}</a>;
            },
            filterable: true
        }, {
            id: 'orderType',
            Header: i18next.t('orderType'),
            accessor: purchase => purchase.order.cartType,
            Cell: row => row.value ? i18next.t(row.value) : '',
            filterable: true,
            filterValues: orderTypes.map(type => ({ value: type, text: i18next.t(type) }))
        }, {
            Header: i18next.t('createDate'),
            accessor: 'payment.createdAt',
            Cell: row => row.value ? new Date(row.value).toLocaleString() : null,
            filterable: true,
            filterDate: new Date()
        }];

        return (
            <section className="pi-campaign-container" size='huge'>
                <div className='pi-campaign-header-bar'>
                    <Header as='h2'>
                        <Icon name='chart pie' color='grey' />
                        <Header.Content>
                            {campaign.name}
                            <Header.Subheader>{campaign.description}</Header.Subheader>
                        </Header.Content>
                    </Header>
                    <Label>
                        {i18next.t('createDate')}
                        <Label.Detail>{new Date(campaign.createdAt).toLocaleString()}</Label.Detail>
                    </Label>
                </div>

                <div className='pi-campaign-usages-grid'>
                    <Header>{i18next.t('loyaltyProgram.cashInBreakdown')}: </Header>

                    <DataGrid
                        data={campaignUsagesReport}
                        columns={columns}
                        getTrGroupProps={(state, rowInfo, column) => {
                            return {};
                        }}
                        paginated
                       
                    />
                </div>

            </section>
        );
    }
}

CampaignDetails.propTypes = {
    loyaltyProgramId: PropTypes.string,
    campaignId: PropTypes.string,
    loyaltyProgram: PropTypes.object,
    campaignReport: PropTypes.array,
    campaignUsagesReport: PropTypes.array,
    fetchLoyaltyProgramCampaigns: PropTypes.func,
    fetchCampaignReport: PropTypes.func,
    fetchCampaignUsagesReport: PropTypes.func,
    
};

function mapStateToProps(state, ownProps) {
    const { benefits, campaigns } = state.loyaltyApp;
    const { campaignReport, campaignUsagesReport } = state.loyaltyApp.reports;
    const { loyaltyProgramId, campaignId } = ownProps.match.params;
    const campaign = campaigns.find(camp => camp.id === campaignId);

    return { loyaltyProgramId, benefits, campaignId, campaign, campaignReport, campaignUsagesReport };
}
export default connect(mapStateToProps, {
    fetchLoyaltyProgramCampaigns,
    fetchCampaignReport,
    fetchCampaignUsagesReport
})(CampaignDetails);
